export type ProgramAccessLevel =
	| 'owner'
	| 'admin'
	| 'manager'
	| 'member'
	| 'read'
	| 'write'
	| null
	| undefined

export function normalizeAccessLevel(
	level: ProgramAccessLevel
): Exclude<ProgramAccessLevel, 'write' | null | undefined> | null {
	if (!level) return null
	if (level === 'write') return 'member'
	return level
}

export function canWriteFeedback(level: ProgramAccessLevel) {
	return ['owner', 'admin', 'manager', 'member'].includes(
		normalizeAccessLevel(level) || ''
	)
}

export function canDeleteFeedback(level: ProgramAccessLevel) {
	return ['owner', 'admin', 'manager'].includes(normalizeAccessLevel(level) || '')
}

export function canManageWidgets(level: ProgramAccessLevel) {
	return ['owner', 'admin'].includes(normalizeAccessLevel(level) || '')
}

export function canManageProjectSettings(level: ProgramAccessLevel) {
	return ['owner', 'admin'].includes(normalizeAccessLevel(level) || '')
}

export function canInviteMembers(level: ProgramAccessLevel) {
	return ['owner', 'admin', 'manager'].includes(normalizeAccessLevel(level) || '')
}

export function isProjectOwner(level: ProgramAccessLevel) {
	return normalizeAccessLevel(level) === 'owner'
}

export function isAccountOwner(teamRole: string | null | undefined) {
	return teamRole === 'owner'
}
